import React, { useState } from 'react';
import { submitContactForm } from '../../services/contactService';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess('');
    setError('');

    try {
      // Add ReCAPTCHA handling if needed
      await submitContactForm(formData);
      setSuccess('Your message has been sent successfully!');
      setFormData({ name: '', email: '', subject: '', message: '' });
    } catch (err) {
      setError(err.message || 'Failed to send message. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="space-extra2-top space-extra2-bottom" id="contact-sec">
      <div
        className="breadcumb-wrapper"
        style={{
          backgroundImage: 'url(/assets/images/contact/contact_bg.jpg)',
          padding: '60px 0',
          backgroundSize: 'cover',
        }}
      >
        <div className="container">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Contact Us</h1>
            <ul className="breadcumb-menu">
              <li><a href="#slider-sec">Home</a></li>
              <li>Contact Us</li>
            </ul>
          </div>
        </div>
      </div>

      <div
        className="space-extra2-top space-extra2-bottom"
        style={{
          backgroundImage: 'url(/assets/images/contact/1.jpeg)',
          padding: '80px 0',
          backgroundSize: 'cover',
        }}
      >
        <div className="container">
          <div className="row flex-row-reverse justify-content-center align-items-center">
            <div className="col-lg-6">
              <form onSubmit={handleSubmit} className="contact-form style2">
                <h3 className="sec-title mb-30 text-capitalize">Contact Us</h3>

                {success && <div className="alert alert-success">{success}</div>}
                {error && <div className="alert alert-danger">{error}</div>}

                <div className="row">
                  <div className="col-12 form-group">
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      placeholder="Full Name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="col-12 form-group">
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      placeholder="Your Email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group col-12">
                    <select
                      name="subject"
                      className="form-select nice-select"
                      value={formData.subject}
                      onChange={handleChange}
                      required
                    >
                      <option value="" disabled>Select Enquiry Type</option>
                      <option value="Book a Tour">Book a Tour</option>
                      <option value="Information">Information</option>
                      <option value="Advice">Advice</option>
                    </select>
                  </div>
                  <div className="form-group col-12 mt-14">
                    <textarea
                      name="message"
                      cols="30"
                      rows="3"
                      className="form-control"
                      placeholder="Your Message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                    ></textarea>
                    {/* Add ReCAPTCHA here if needed */}
                  </div>
                  <div className="form-btn col-12 mt-14">
                    <button type="submit" className="th-btn style3" disabled={loading}>
                      {loading ? 'Sending...' : 'Send Message'}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;